<template>
  <div
    id="hero-area"
    class="main-content hero-area-bg fixed-height-content-lg container-full-bg flex"
  >
    <div class="container flex-row flex bot-85 my-md-auto">
      <div class="row justify-content-between">
        <div class="col-md-5">
          <div class="hero-portrait">
            <text-portrait-glitch
              src="/img/background/kobina-hero-pic-i.webp"
              :text="portraitText"
              alt="Kobina Koomson — headshot rendered as a typographic portrait"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="contents page-header-inner home-text text-left mb-5">
            <h3 class="mt-4 mb-3">
              <span class="font-weight-light intro">
                <span class="official-name font-weight-bold">
                  {{ name }}
                </span>
              </span>
            </h3>
            <p>
              Highly experienced
              <span
                class="skill-highlight badge-pill badge badge-light pb-0 d-none d-lg-inline"
                >Senior Software Engineer</span
              >
              <animated-three-d-text
                class="text-secondary bg-white badge px-2 text-monospace text-base d-inline-flex d-lg-none"
              />
              with a passion for problem solving. This is my personal space
              where I share my thoughts, ideas, and projects.
            </p>
            <p class="text-muted mt-2">
              A full-stack engineer with years of experience
              <span class="text-white font-weight-600">designing</span>,
              <span class="text-white font-weight-600">building</span> and
              <span class="text-white font-weight-600">shipping</span> highly
              scalable, secure, and reliable production grade applications. I'm
              self-motivated, detail-oriented, always looking to learn new
              things and grow. I’m also result oriented and that accounts for
              the keen interest I put in output and finishing.
            </p>
          </div>
          <div
            class="d-flex flex-wrap justify-content-md-start justify-content-center gap-2"
          >
            <span
              v-for="(skill, index) in techStack"
              :key="'gd-' + index"
              class="skill-tag tag"
              >{{ skill }}</span
            >
          </div>
          <div
            class="hero-buttons d-flex justify-content-md-start justify-content-center gap-3 my-5"
          >
            <router-link to="/about">
              <b-button
                class="py-2 px-4 btn btn-primary border-0"
                pill
                style="background-color: rgb(244, 168, 4)"
              >
                About<span class="d-none d-lg-inline"> Me</span>
              </b-button>
            </router-link>
            <router-link to="/blog" class="">
              <b-button
                class="py-2 px-4 btn btn-primary border-0"
                pill
                style="background-color: rgb(253, 86, 25)"
              >
                Blog
              </b-button>
            </router-link>
            <!-- <a href="/projects" class="">
              <b-button class="py-2 px-4 btn btn-primary border-0" pill style="background-color: rgb(253,86,25)">
                <span class="d-none d-lg-inline">View </span>Projects
              </b-button>
            </a>-->
            <!--        <a href="/contact" class="">-->
            <!--          <b-button class="py-2 px-4 btn btn-primary text-secondary border-0" pill style="background-color: rgb(194,248,3)">-->
            <!--          Contact<span class="d-none d-lg-inline"> Me</span>-->
            <!--          </b-button>-->
            <!--        </a>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AnimatedThreeDText from "@/components/animated-three-d-text-prisms.vue";
import TextPortraitGlitch from "@/components/TextPortraitGlitch.vue";
import resumeData from "@/config/resume-data.js";

export default {
  name: "hero-section",
  components: { AnimatedThreeDText, TextPortraitGlitch },
  data() {
    return {
      officialName: "Kobina G. Koomson",
      name: "Kobina Koomson",
      nameTyped: false,
      skillsTyped: false,
      bgImage:
        "https://kobina.sirv.com/Images/kobina-koomson-w/background/hero16x9-3-br.jpg?q=3",
      bgChanged: false,
      lastScrollTop: 0,
      jumpIndex: 0,
      shadowOfficialName: [],
      techStack: [
        "TypeScript",
        "JavaScript",
        "Python",
        "Rust",
        "PostgreSQL",
        "MySQL",
        "MongoDB",
        "Redis",
        "Django",
        "React Native",
        "RESTful APIs",
        "Vue.js + [Nuxt.js, Vue Router]",
        "Node.js + [Express, Nest.js, Fastify]",
        "React.js + [Next.js, Remix Run]",
      ],
    };
  },
  props: [],
  computed: {
    portraitText() {
      // the text the portrait is drawn from — flows like the reference poster
      return [
        `MY NAME IS ${this.officialName}.`,
        "I AM A SOFTWARE ENGINEER.",
        resumeData.professionalSummary,
        `I BUILD WITH ${this.techStack.join(" ")}.`,
      ].join(" ");
    },
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="scss">
@import "../../assets/styles/scss/includes/mixins";

.main-content {
  margin-top: 102px;
}
</style>
<style scoped lang="scss">
@import "../../assets/styles/scss/colors";
@import "../../assets/styles/scss/media-queries";
@import "../../assets/styles/scss/mixins/breakpoints";
@import "../../assets/styles/scss/includes/mixins";

.hero-area-bg {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  img {
    width: 100%;
  }

  .col-12 {
    padding: 0;
    background-repeat: no-repeat;
    transition: all 0.8s ease-out;
    background-size: cover;
    background-position: center center;

    &.loaded {
      filter: blur(0) grayscale(0.65);
    }
  }
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.8;
}

#hero-area {
  overflow: hidden;
  position: relative;

  .contents {
    .btn {
      margin: 0 10px 0;
      font-size: 16px;
      padding: 12px 40px;
      text-transform: uppercase;
    }
  }
}

.main-actions {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.container-full-bg {
  display: flex;
}

// on phones the full-width portrait ate over half the screen before the
// intro copy started — cap it and centre it above the text instead
.hero-portrait {
  @media (max-width: 767.98px) {
    width: min(60vw, 250px);
    margin: 0 auto 1.75rem;
  }
}

.home-text {
  h3 {
    margin: 0 auto;

    span.official-name span {
      display: unset;
    }
  }

  .intro {
    font-size: 2.5rem;
  }
}

span.official-name {
  //font-size: 90px;

  span {
    display: unset;
  }
}

.skill-highlight {
  width: auto;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 3px;
  color: #000;
  margin-bottom: 10px;
}

.about-d-chevron {
  height: 45px;
  width: 45px;
  bottom: 22.5px;
  left: calc(50% - 22.5px);
  background: url(../../assets/img/scroll.gif) 50% 50% no-repeat
    rgba(215, 181, 94, 0);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  -webkit-transition: all 300ms ease-in-out 0s;
  -moz-transition: all 300ms ease-in-out 0s;
  -ms-transition: all 300ms ease-in-out 0s;
  -o-transition: all 300ms ease-in-out 0s;
  transition: all 300ms ease-in-out 0s;
  position: absolute;

  &:hover {
    background-color: #ffcf02;
    transform: scale(1.01, 1.01);
  }
}

.more-tooltip {
  background-color: $accent-color;
  width: 250px;
  height: auto;
  border-radius: 3px;
  color: #000;
  padding: 10px;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px;
    border-color: transparent;
  }

  &::before {
    bottom: -20px;
    left: calc(50% - 10px);
    border-top-color: #ffcf02;
  }

  p {
    font-size: 16px;
    font-weight: 400;
  }
}

.hero-buttons {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;

  div {
    height: 60px;
    width: 140px;
  }
}

@media (max-width: 992px) {
  .main-actions {
    margin-top: calc(65%);
  }

  //.skill-highlight {
  //  -webkit-border-radius: 0;
  //  -moz-border-radius: 0;
  //  border-radius: 0;
  //}
}
</style>
<style lang="scss">
@import "../../assets/styles/scss/media-queries";
@import "../../assets/styles/scss/includes/mixins";

//.main-content {
//  //height: calc(100vh - 124px);
//
//  &.fixed-footer {
//    //height: calc(100vh - 224px);
//  }
//}

@keyframes fadeBlur {
  0% {
    filter: grayscale(0);
  }
  100% {
    filter: grayscale(0.65);
  }
}

.fade-blur,
.fade-blur.blurry-bg-vision.loaded {
  animation-name: fadeBlur;
  animation-duration: 0.8s;
  filter: grayscale(0.65);
}

//@include max-screen-size(760px) {
//  .skill-highlight {
//    -webkit-border-radius: 0;
//    -moz-border-radius: 0;
//    border-radius: 0;
//  }
//}
//
//@include min-screen-size(576px) {
//  .official-name {
//    font-weight: bold;
//    //font-size: 40px;
//  }
//}
</style>
